import { useContext } from 'react';

import { LoadableAncestorsContext } from '../LoadableAncestors.tsx';

export function useSSRPlaceholderReplaceIdProp(): {
	'data-ssr-placeholder-replace': string | undefined;
} {
	const { placeholderReplaceId } = useContext(LoadableAncestorsContext);
	return { 'data-ssr-placeholder-replace': placeholderReplaceId };
}
